import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { colors } from '@naf-simba/theme';

export const SuggestionWrapper = styled.div`
  margin-top: ${spacing.space8};
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${nafColor.signature.black};
`;

export const SuggestionLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  font-family: inherit;
  text-decoration: none;
  color: ${nafColor.information.information};

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid ${colors.secondary[500]};
    outline-offset: 2px;
  }
`;
